import React, { useState } from 'react';
import ShopPictureField from './ShopPictureField';
import DetailField from './DetailField';
import ImageModal from './ImageModal';

function LeftColumnSection({ state }) {
  const [isVerificationIdPopupOpen, setIsVerificationIdPopupOpen] = useState(false);

  const openVerificationIdPopup = () => setIsVerificationIdPopupOpen(true);
  const closeVerificationIdPopup = () => setIsVerificationIdPopupOpen(false);

  return (
    <div className="TextContainerLeft">
      <ShopPictureField imageSrc={state.banner} />

      {state.user_name && (
        <DetailField
          label="Owner Name"
          name="user_name"
          value={state.user_name || "undefined"}
        />
      )}

      {state.mobile_number && (
        <DetailField
          label="Mobile Number"
          name="mobile_number"
          value={state.mobile_number}
        />
      )}

      {state.verification_type && (
        <DetailField
          label="Verification Id Type"
          name="verification_type"
          value={state.verification_type}
        />
      )}

      {state.verification_id && (
        <DetailField
          label="Verification Id"
          name="verification_id"
          value={state.verification_id}
        />
      )}

      {state.doc_file && (
        <div>
          <div className="Label_name_details">
            <label>Verification Id Picture</label>
          </div>
          <div className="input_field">
            <img
              alt="img"
              id="zoom"
              height="200"
              onClick={openVerificationIdPopup}
              src={state.doc_file}
            />
            <ImageModal
              isOpen={isVerificationIdPopupOpen}
              onClose={closeVerificationIdPopup}
              imageSrc={state.doc_file}
            />
          </div>
        </div>
      )}

      {state.pgmdetail?.user_type?.[0]?.user_type_slug === "retailer" ? (
        <DetailField
          label="Account Number"
          name="id"
          value={state.id || ""}
        />
      ) : state.account_number ? (
        <DetailField
          label="Account Number"
          name="account_number"
          value={state.account_number || ""}
        />
      ) : null}

      {state.registered_at && (
        <DetailField
          label="Registration Date"
          name="registered_at"
          value={state.registered_at}
        />
      )}

      {state?.pgmdetail?.user_document &&
        state.pgmdetail.user_document.map((item, index) => (
          <DetailField
            key={index}
            label={item?.doc_type_name}
            name={item?.doc_type_slug}
            value={item?.meta_value}
          />
        ))}

      {state?.location_link && (
        <DetailField
          label="Geomap"
          name="location_link"
          value={state.location_link}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (state.location_link) {
              window.open(state.location_link, "_blank");
            }
          }}
        />
      )}

      {state.refer_code && (
        <DetailField
          label="Referral Code"
          name="refer_code"
          value={state.refer_code}
        />
      )}
    </div>
  );
}

export default LeftColumnSection;
